// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603020804/js/" + chunkId + "." + {"44":"1a936280","225":"33678721","481":"48145081","486":"d3a7983b","770":"8c15bc13"}[chunkId] + ".0.18819966742270844.chunk.js";
};